// Share button functionality
function initShareButtons() {
  // Remove existing share buttons first to avoid duplicates
  document.querySelectorAll('.product-card-share').forEach(btn => btn.remove());
  
  // Create share buttons for each product card
  const productCards = document.querySelectorAll('.product-media-container--zoomable > .product-media');
  
  productCards.forEach(card => {
    // Only add share button if it doesn't already exist
    if (!card.querySelector('.product-card-share')) {
      const shareBtn = createShareButton(card);
      card.style.position = 'relative';
      card.appendChild(shareBtn);
    }
  });
}
// Watch for DOM changes (when swatches are clicked)
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    // Check if product cards were added or updated
    if (mutation.type === 'childList') {
      let shouldReinit = false;
      
      // Check if any product cards were added/removed
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 &&
            node.querySelector('.product-media-container--zoomable > .product-media')) {
          shouldReinit = true;
        }
      });
      
      if (shouldReinit) {
        // Small delay to ensure DOM is fully updated
        setTimeout(initShareButtons, 100);
      }
    }
  });
});

// Start observing when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
// Initialize when page loads
document.addEventListener('DOMContentLoaded', initShareButtons);

function createShareButton(productCard) {
  const shareContainer = document.createElement('div');
  shareContainer.className = 'product-card-share';
  
  const shareBtn = document.createElement('button');
  shareBtn.className = 'share-btn';
  shareBtn.innerHTML = `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/>
      <polyline points="16 6 12 2 8 6"/>
      <line x1="12" y1="2" x2="12" y2="15"/>
    </svg>
  `;
  
  const shareOptions = document.createElement('div');
  shareOptions.className = 'share-options';
  shareOptions.innerHTML = `
    <div class="share-option" data-platform="facebook">
      <svg viewBox="0 0 24 24" fill="#1877F2">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
      Facebook
    </div>
    <div class="share-option" data-platform="whatsapp">
      <svg viewBox="0 0 24 24" fill="#25D366">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.418"/>
      </svg>
      WhatsApp
    </div>
    <div class="share-option" data-platform="pinterest">
      <svg viewBox="0 0 24 24" fill="#BD081C">
        <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.042-3.441.219-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24.009c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017 0z"/>
      </svg>
      Pinterest
    </div>
    <div class="share-option" data-platform="copy">
      <svg viewBox="0 0 24 24" fill="currentColor">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
      </svg>
      Copy Link
    </div>
  `;
  
  shareBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    shareOptions.style.display = shareOptions.style.display === 'block' ? 'none' : 'block';
  });
  
  // Handle share options
  shareOptions.querySelectorAll('.share-option').forEach(option => {
    option.addEventListener('click', function() {
      const platform = this.dataset.platform;
      shareProduct(platform, productCard);
      shareOptions.style.display = 'none';
    });
  });
  
  shareContainer.appendChild(shareBtn);
  shareContainer.appendChild(shareOptions);
  
  // Close share options when clicking outside
  document.addEventListener('click', function() {
    shareOptions.style.display = 'none';
  });
  
  return shareContainer;
}

function shareProduct(platform, productCard) {
  const productLink = productCard.querySelector('a')?.href || window.location.href;
  const productTitle = productCard.querySelector('.product-card__title, .card__heading')?.textContent || document.title;
  const productImage = productCard.querySelector('img')?.src || '';
  
  const shareUrls = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(productLink)}`,
    whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(productTitle)}%20${encodeURIComponent(productLink)}`,
    pinterest: `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(productLink)}&media=${encodeURIComponent(productImage)}&description=${encodeURIComponent(productTitle)}`,
    copy: productLink
  };
  
  if (platform === 'copy') {
    navigator.clipboard.writeText(productLink).then(() => {
      alert('Product link copied to clipboard!');
    });
  } else {
    window.open(shareUrls[platform], '_blank', 'width=600,height=400');
  }
}